const TranspaisTripType = {
  single: 'Sencillo',
  round: 'Ida y vuelta',
  open: 'Abierto',
}

export default TranspaisTripType